import { getFileExtension } from "../../utilFunctions";

export const formatDocumentDetails = (documentDetails = []) => {
  return documentDetails.map((doc, index) => ({
    id: doc.docId,
    docName: `Document ${index + 1}`,
    docURL: doc.docURL,
    fileType: getFileExtension(doc.docName), // 'pdf', 'image', 'video', or 'other'
  }));
};